import Cookies from 'js-cookie';

import { COOKIE_KEY } from '../constants';

export const consentCookieExists = (): boolean => !!Cookies.get(COOKIE_KEY);
